<template>
<div>
	<div class="flex py-2 m-2 px-4">
		<div class="flex-1 text-left">
			<p class="text-lg font-extrabold">Välj order</p> 
			<p class="text-md font-light mt-2" v-text="customer.id + ' ' + customer.title"></p>
		</div>
		<div class="flex-1">
			<button @click="dismissModal()" class="float-right text-grey hover:text-grey-darker">
				<svg class="fill-current h-5 w-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/></svg>
			</button>
		</div>
	</div>

	<div class="max-h-screen-50 py-4 overflow-scroll">
		<div class="mb-4 mx-12">
			<div class="flex flex-wrap h-full">
				<div v-if="orders.length" class="border border-grey-light bg-white rounded mx-8 my-8 shadow">
					<div class="flex flex-col w-full">
						<table class="table table-hover table-responsive table-scrollable-50 mb-0 w-full">
							<thead>
								<tr>
									<th>År</th>
									<th>Antal samlingsprov</th>
									<th>Areal</th>
									<th>Kommentar</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="order in orders" :key="order.id">
									<td v-text="order.year"></td>
									<td>
										<p class="inline font-bold" v-text="order.collection_samples.length"></p>
										<p class="inline"> samlingsprov</p>
									</td>
									<td v-text="order.areal"></td>
									<td v-text="order.comment"></td>
									<td>
										<div class="px-2 flex justify-center">
											<a href="#" @click="selectOrder(order)" class="flex items-center w-1/2 justify-center py-2 text-sm text-center text-white bg-blue hover:bg-blue-dark rounded shadow-light font-bold">
												Välj
												<svg class="h-3 w-3 ml-1 fill-current" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"/></svg>
											</a>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<p v-else-if="!loading" class="w-full text-2xl text-center font-medium">Inga ordrar med samlingsprover hittades för vald kund</p>
			</div>
		</div>
	</div>

	<div class="w-full bg-grey-lightish rounded-b pb-16">
		<div class="float-left flex ml-4 mt-4">
			<button @click="goBack()" class="items-center w-auto py-2 px-2 pr-2 text-sm text-center text-white block bg-grey-dark hover:bg-grey-darker rounded shadow-light font-bold">
				<svg class="text-white fill-current w-3 h-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"/></svg>
				Gå tillbaka
			</button>
		</div>
	</div>
</div>
</template>

<script>

import axios from 'axios'

import { mapGetters } from 'vuex'

export default {

	data() {
		return {
			orders: [],
			loading: true
		}
	},

	computed: {
		...mapGetters({
			customer: 'customer/customer',
		}),
	},

	mounted() {
		this.fetchOrders()
	},

	methods: {

		fetchOrders() {
			this.loading = true
			axios.get('/order?customer_id=' + this.customer.id + '&include_collection_samples=true&include_polygons=true')
			.then(response => {
				this.orders = response.data
				this.loading = false
			})
		},

		selectOrder(order) {
			this.$store.dispatch("customer/SET_ORDER", order)
		},

		goBack() {
			this.$emit('goBack')
		},

		dismissModal() {
			this.$emit('closeModal')
		}

	}
}
</script>